// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1wnfz","upload":"Small_upload__1Fa8t","imageWrap":"Small_imageWrap__31SJo","removeBtn":"Small_removeBtn__3uH00"};